export const skillList = [
  {
    category: "frontend",
    items: [
      {
        src: "/images/HTML.svg",
        alt: "HTML",
        txt: "웹 표준과 접근성 지침을 준수하여 다양한 웹 페이지를 구축할 수 있습니다.",
      },
      {
        src: "/images//CSS.svg",
        alt: "CSS",
        txt: " 다양한 스타일링 기법과 선택자를 사용하여 웹 페이지의 디자인과 레이아웃을 구현할 수 있습니다.",
      },
      {
        src: "/images/Javascript.svg",
        alt: "Javascript",
        txt: "javascript의 DOM 조작과 이벤트 처리 등의 핵심 개념에 익숙합니다. ES6이상의 문법을 활용할 수 있습니다.",
      },
      {
        src: "/images/Styled-components.svg",
        alt: "Styled-components",
        txt: "컴포넌트의 레이아웃을 구성할 수 있고 컴포넌트에 props 전달을 통해 스타일을 동적으로 변경할 수 있습니다.",
      },
      {
        src: "/images/NEXT.js.svg",
        alt: "NEXT.js",
        txt: "기본적인 기능을 이해하고 있으며,SSR의 개념을 알고 있습니다. 간단한 프로젝트에서 Next.js를 활용한 경험이 있으며, 필요에 따라 추가적인 학습을 통해 더 깊이 있는 활용이 가능하다는 자신감을 가지고 있습니다.",
      },
      {
        src: "/images/React.svg",
        alt: "React",
        txt: "컴포넌트 재사용성을 극대화하여 코드의 효율성을 높이고 다양한 React Hooks를 사용할 수 있습니다.",
      },
      {
        src: "/images/TS.svg",
        alt: "TS",
        txt: "TypeScript를 활용하여 자바스크립트 코드에 타입을 명시적으로 적용할 수 있습니다. 이를 통해 코드의 안정성을 높이고, 예상치 못한 오류를 사전에 방지할 수 있습니다.",
      },
    ],
  },

  {
    category: "Collaboration & Tools",
    items: [
      {
        src: "/images/figma.svg",
        alt: "figma",
        txt: "사용자 중심의 UI/UX 디자인을 구현할 수 있습니다.",
      },
      {
        src: "/images/github.svg",
        alt: "github",
        txt: "소스 코드의 버전 관리를 체계적으로 수행할 수 있습니다. 브랜치를 통한 작업 분리, 풀 리퀘스트를 통한 코드 리뷰 등을 통해 팀 프로젝트의 효율성을 높일 수 있습니다.",
      },
      {
        src: "/images/notion.svg",
        alt: "notion",
        txt: "Notion을 활용하여 문서화를 진행할 수 있습니다.",
      },
      {
        src: "/images/yarn.svg",
        alt: "yarn",
        txt: "Yarn을 통한 패키지 관리에 능숙합니다. 의존성 관리와 버전 관리를 효율적으로 진행함으로써 프로젝트의 안정성을 유지할 수 있습니다. ",
      },
      {
        src: "/images/npm.png",
        alt: "npm",
        txt: "Npm을 통한 패키지 관리에 능숙합니다. 의존성 관리와 버전 관리를 효율적으로 진행함으로써 프로젝트의 안정성을 유지할 수 있습니다. ",
      },
      {
        src: "/images/Firebase.svg",
        alt: "Firebase",
        txt: "실시간 데이터베이스를 구현하고 사용자 인증 기능을 개발할 수 있습니다. 이를 활용하여 서버리스 환경에서 효율적인 백엔드를 구축하며, 애플리케이션의 개발 시간을 단축하고 관리를 효과적으로 수행할 수 있습니다.",
      },
      {
        src: "/images/vercel.svg",
        alt: "vercel",
        txt: "지속적인 Deployment와 배포를 경험하였습니다. 프로젝트의 변경 사항을 실시간으로 반영하여 웹사이트를 유지보수하며 웹 애플리케이션을 배포하고 관리할 수 있습니다.",
      },
    ],
  },
];
